
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { HttpService } from '../../modules/shared/services/http.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LoadingService } from 'src/app/modules/shared/services/loading.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as Crypto from 'node_modules/crypto-js';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent {

  /**
   * Die Formgroup für das LoginFormular
   */
  loginForm = new FormGroup({
    Username: new FormControl(),
    Password: new FormControl(),
  });

  private jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(
    private http: HttpService,
    private router: Router,
    private auth: AuthService,
    private toast: ToastrService,
    private loading: LoadingService,
  ) {
    if (this.auth.isAuthenticated()) {
      this.router.navigate([this.auth.getLandingPage()]);
    }
  }

  /**
   * Übermittelt die Login-Daten an die Schnittstelle
   */
  submitCredentials() {
    const credentials = this.getLoginCredentials();
    this.http.post(
      '/api/auth/login',
      credentials,
      response => this.handleLoginSuccess(response),
      response => this.handleLoginError(response)
    );
  }

  private handleLoginSuccess(response: any) {
    if (response.status === 0) {
      this.toast.success(response.message, 'Erfolg');
      const jwt = response.jwt;
      console.log(this.jwtHelper.decodeToken(jwt).sub);
      const landingPage = this.jwtHelper.decodeToken(jwt).sub.landingPage || '/home';
      this.auth.setJwtToken(jwt);
      this.auth.setLoginState(true);
      this.loading.setLoadingState(true);
      setTimeout(() => {
        this.loading.setLoadingState(false);
        this.router.navigate([landingPage]);
      }, 500);
    } else {
      console.log(response);
    }
  }

  private handleLoginError(response) {
    this.toast.error(response.error.message);
    if (response.error.errors) {
      Object.keys(response.error.errors).forEach((field) => {
        this.loginForm.controls[field].setErrors(response.error.errors[field]);
      });
    }
  }

  /**
   * Bereitet die LoginCredentials vor und gibt sie für den API-Call zurück.
   */
  private getLoginCredentials(): object {
    const credentials = this.loginForm.value;
    return {
      Username: credentials.Username,
      Password: this.encryptPassword(credentials.Password)
    };
  }

  /**
   * Führt ersten Schritt der Passwort verschlüsselung durch und gibt es zurück
   */
  private encryptPassword(password: string): string {
    return Crypto.SHA1(password) + Crypto.MD5(password);
  }

  /**
   * Setzt das Formular beim Klick auf "Zurücksetzen" zurück.
   */
  resetForm() {
    this.loginForm.reset();
  }
}
